module.exports = __webpack_public_path__ + "fonts/TT-Norms_Regular.7046079.woff";